import { render, staticRenderFns } from "./Waba.vue?vue&type=template&id=1ea70fa6&"
import script from "./Waba.vue?vue&type=script&lang=js&"
export * from "./Waba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports